import { TAdminSupplementInquiryStatus } from '@interfaces/adminSupplements';

import useAdminSupplementInquiryStatuses from './useAdminSupplementInquiryStatuses';

const useAdminSupplementInquiryStatusById = (statusId?: TAdminSupplementInquiryStatus) => {
  const adminSupplementInquiryStatuses = useAdminSupplementInquiryStatuses();
  return adminSupplementInquiryStatuses.find(status => status.id === statusId);
};

export default useAdminSupplementInquiryStatusById;
